import React, { useState, useEffect } from 'react';
import { getCategoryById, updateCategory } from '../../services/categoryService';
import { useNavigate, useParams } from 'react-router-dom';
import CategoryForm from './CategoryForm';
import { useGroupContext } from '../Groups/useGroupContext';

const EditCategory = () => {
  const [category, setCategory] = useState();
  const navigate = useNavigate();
  const { getContextParams } = useGroupContext();
  const { id } = useParams();

  useEffect(() => {
    const contextParams = getContextParams();
    const fetchCategory = async () => {
      try {
        const category = await getCategoryById(id, contextParams);
        setCategory(category[0]);        
      } catch (error) {
        console.error(error);
        alert('Error fetching category details');
      }
    };

    fetchCategory();
  }, [id]);

  const handleUpdate = async (updatedCategory) => {
    const contextParams = getContextParams();
    try {
      await updateCategory(id, updatedCategory, contextParams);
      alert('Category updated successfully');
      navigate('/categories/');
    } catch (error) {
      console.error(error);
      alert('Error updating category, error: '+ error.response.data);
    }
  };

  return category ? (<CategoryForm isEdit = {true} data={category} onSubmit={handleUpdate}/>
  ) : (
    <p>Loading...</p>
  )
  };

export default EditCategory;
